import React from "react";
import {
  Ticket,
  GraduationCap,
  Briefcase,
  Calendar,
  Tag,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";

const Inscripcion2 = () => {
  const registrationDeadlines = "15 de julio de 2026";
  const discountAmount = 10; // Descuento de 10 dólares

  const pricingData = [
    {
      type: "Estudiante de grado",
      originalPrice: 60,
      icon: <GraduationCap className="w-8 h-8 text-blue-500" />,
      link: "https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIkNPTDAiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQxIiwibm9tYnJlQ3Vyc28iOiAiWElWIENPTEFQTEFNRUQgUFJFR1JBRE8iLCJzb2JyZXBhc2FyQ3Vwb3MiOiAiTiJ9",
      description: "Para estudiantes de carreras de tercer nivel (grado).",
    },
    {
      type: "Estudiante de posgrado",
      originalPrice: 70,
      icon: <Ticket className="w-8 h-8 text-purple-500" />,
      link: "https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIkNPTDEiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQyIiwibm9tYnJlQ3Vyc28iOiAiWElWIENPTEFQTEFNRUQgUE9TR1JBRE8iLCJzb2JyZXBhc2FyQ3Vwb3MiOiAiTiJ9",
      description:
        "Dirigido a maestrandos y doctorandos en áreas afines (posgrado).",
    },
    {
      type: "Profesional",
      originalPrice: 90,
      icon: <Briefcase className="w-8 h-8 text-emerald-500" />,
      link: "https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIkNPTDIiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTQzIiwibm9tYnJlQ3Vyc28iOiAiWElWIENPTEFQTEFNRUQgR0VORVJBTCIsInNvYnJlcGFzYXJDdXBvcyI6ICJOIn0",
      description:
        "Entrada general para profesionales, investigadores y docentes.",
    },
  ];

  const calculateDiscount = (price) => {
    return (price - discountAmount).toFixed(2);
  };

  return (
    <div className="relative-block">
      {/* Banner de Descuento (Actualizado a $10 menos) */}

      <div className="bg-[#459e5a] shadow-2xl"> 
      <div className=" max-w-6xl m-auto p-6 mb-6  text-white relative overflow-hidden">
        <div className="flex flex-col md:flex-row items-center justify-between ">
          <div className="relative z-10 flex items-center gap-5 mb-6 md:mb-0">
            <div>
              <Tag className="w-10 h-10" />
            </div>
            <div>
              <h2 className="md:text-1xl text-2xl font-bold text-white">
                ¡Aprovecha nuestro descuento por pronto pago!
              </h2>
              <p className="text-indigo-100 mt-1 flex items-center gap-2 text-lg">
                <Calendar className="w-5 h-5 text-yellow-400" />
                Recibe{" "}
                <span className="font-bold text-white ">
                  USD $10 de descuento
                </span>{" "}
                hasta el {registrationDeadlines}.
              </p>
            </div>
          </div>
       
          {/* Elementos decorativos */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-400/10 rounded-full -ml-10 -mb-10 blur-2xl"></div>
        </div>{" "}
      </div>  </div>

      {/* Tarjetas de Precios */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl m-auto mt-12">
        {pricingData.map((tier, index) => (
          <div
            key={index}
            className="bg-white rounded-[2rem] p-8 shadow-sm border border-slate-200 hover:shadow-2xl transition-all duration-500 flex flex-col relative overflow-hidden group"
          >
            <div className="mb-6 relative z-10">
              <div className="inline-flex p-4 rounded-2xl bg-slate-50 mb-5 group-hover:scale-110 transition-transform duration-300">
                {tier.icon}
              </div>
              <h3 className="text-2xl font-bold  tracking-tight text-[#459e5a]">
                {tier.type}
              </h3>
              <p className="text-slate-500  ">
                {tier.description}
              </p>
            </div>

            <div className="mb-8 relative z-10">
              <div className="flex items-center gap-3">
                <span className="text-slate-400 line-through text-xl">
                  USD {tier.originalPrice}
                </span>
                <div className="bg-red-50 text-red-600 text-[10px] font-black px-2.5 py-1 rounded-lg uppercase tracking-wider border border-red-100">
                  -$10 OFF
                </div>
              </div>
              <div className="flex items-baseline gap-1.5 mt-2">
                <span className="text-5xl font-black text-slate-900 tracking-tighter">
                  USD {calculateDiscount(tier.originalPrice)}
                </span>
              </div>
              <p className="text-xs font-semibold text-indigo-600 mt-2 uppercase tracking-widest">
                Tarifa Especial
              </p>
            </div>

            <a
              href={tier.link}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-[#459e5a] text-white py-5 rounded-2xl font-bold flex items-center justify-center gap-3 hover:bg-[#004270] transition-all duration-300 shadow-lg hover:shadow-indigo-200 group/btn relative z-10"
            >
              Inscríbete ahora
              <ArrowRight className="w-5 h-5 group-hover/btn:translate-x-1.5 transition-transform" />
            </a>

            {/* Adorno sutil de fondo en la tarjeta */}
            <div className="absolute top-0 right-0 w-24 h-24 bg-slate-50 rounded-bl-full -z-0 opacity-50 group-hover:bg-indigo-50 transition-colors"></div>
          </div>
        ))}
      </div>

      {/* Nota aclaratoria */}
      <div className="mb-8 mt-3 bg-white/50 backdrop-blur-sm rounded-3xl  text-center mt-8">
        <p className="text-slate-500 text-sm max-w-3xl mx-auto leading-relaxed">
          * El descuento de USD $10 es aplicable únicamente para inscripciones
          realizadas y pagadas antes del 15 de julio de 2026. A partir del 16 de
          julio, se cobrará la tarifa regular (USD 60, 70 o 90 según
          corresponda).
        </p>
      </div>
    </div>
  );
};

export default Inscripcion2;
